import { render, staticRenderFns } from "./adjustments.vue?vue&type=template&id=286ac646"
import script from "./adjustments.vue?vue&type=script&lang=js"
export * from "./adjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports